module.exports = __webpack_public_path__ + "img/img-apart-cobertura.2b61857b.png";